import styled, { keyframes } from 'styled-components';
import { layout } from 'src/components/base';
import { Dropdown as DropdownContainer } from '@prisjakt/ui/dropdown';

export const Options = styled.div`
  display: flex;
  align-items: center;
  flex-flow: column;
  transition: opacity ease 0.25s;
  justify-content: center;
`;

export const Option = styled.button`
  width: 100%;
  white-space: nowrap;
  cursor: pointer;
  padding: ${layout.measurements.spacing050};

  &:hover {
    background: ${p => p.theme.dropdowns.secondary.hoverBackground};
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const ReportOverlay = styled.div`
  color: ${p => p.theme.text.secondary};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  animation: ${fadeIn} 250ms ease-in-out 1;
`;

export const Dropdown = styled(DropdownContainer)`
  min-height: 100%;
`;
